export default {
    email: null,
    firstName: null,
    id: null,
    lang: null,
    lastName: null,
  }